import * as React from "react";
import LanguageContext from "./hooks/LanguageContext";
import parse from 'html-react-parser';
import ModalInstruction from "./ModalInstruction";
import { getText } from "../utils/languageUtils";

const ImagePdfLinkComponent = ({ question, handleNextClick, selectedOptions, MarkAsDoneQuiz, currentPage, totalCount }) => {
  const { language } = React.useContext(LanguageContext);
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleImageClick = () => {
    // Always mark as done
    MarkAsDoneQuiz("imagemap");

    // Only call handleNextClick for intermediate pages
    // For the last page, handleSuccess in QuestionPage.js will handle navigation
    if (currentPage < totalCount) {
      handleNextClick();
    }
  };

  // Clicking the hotspot is the only way to complete this question. Hotspot
  // coordinates are per language, so a question can have them for one language and
  // not another; without this fallback the image has no clickable region in those
  // languages and the question can never be marked.
  const areaCoords = getText(question.coords, language);
  const hasAreaCoords = typeof areaCoords === "string" && areaCoords.trim().length > 0;

  return (
    <>
      <div className='justify-content-end d-flex' >
        <div onClick={handleShow}>
          <img src={require("../assets/images/instructions.png")} className='mobielViewIcon' alt="instructions" />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="sectionsBox">
            <p className="mb-0 text-center">
              {getText(question.title, language)}
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 ">
          {getText(question.description, language).length > 0 && <div className="contentbox mb-2 mt-3">
            <div className="content_safty ">
              {parse(getText(question.description, language))}
            </div>
          </div>
          }
        </div>
      </div>
      <div className="d-flex justify-content-center mx-3">
        <div className="mx-2">
          <img
            src={getText(question.file_path, language)}
            useMap={hasAreaCoords ? "#image-map" : undefined}
            onClick={hasAreaCoords ? undefined : handleImageClick}
            style={hasAreaCoords ? undefined : { cursor: "pointer" }}
            alt="interactive content"
          />
          {hasAreaCoords && (
            <map name={"image-map"}>
              <area alt={"first link"} title={"first link"} onClick={handleImageClick} coords={areaCoords} shape={"rect"} />
            </map>
          )}


        </div>
      </div>


      <ModalInstruction show={show} handleClose={handleClose} inst={parse(getText(question.instruction, language))} />
    </>
  )
};
export default ImagePdfLinkComponent;
